import { format } from "date-fns";

export const formatAwsDateString = (
  dateString?: string
): string | undefined => {
  if (!dateString) return undefined;

  const date = new Date(
    dateString.indexOf(":") === -1 ? `${dateString} 00:00:00` : dateString
  );

  return format(date, "M/d/yyyy");
};
